import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import IconButton from "@mui/material/IconButton";
import InstagramIcon from "@mui/icons-material/Instagram";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Logo from "./../../Assets/logo.png";
import TikTokIcon from "./../../Assets/tik.png"
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation } from "react-router-dom";

const pages = [
  { name: 'HOME', path: '/' },
  { name: 'REGULAR MENU', path: '/regular-menu' },
  { name: 'VEGAN MENU', path: '/vegan-menu' },
  { name: 'VIETNAMESE TEA CEREMONY', path: '/vietnamese-tea-ceremony' },
  { name: 'WHOLESALE', path: '/wholesale' },
];

const ORDER_URL = 'https://order.toasttab.com/online/dong-hung-vien';

const orderButtonSx = {
  backgroundColor: '#00aae3',
  color: '#fff',
  borderRadius: '999px',
  px: 2,
  minHeight: 32,
  fontSize: '13px',
  fontWeight: 700,
  fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#33BBE8',
    boxShadow: 'none',
  },
};

function Navbar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  const activePage =
    pages.find((page) => page.path === location.pathname)?.name || 'Home';

  // Add this missing function
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsDrawerOpen(open);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'rgba(41, 43, 53, 0.95)',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'background-color 0.3s ease',
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          overflow: 'hidden',
        }}
      >
        {/* Logo */}
        <Box>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={Logo} alt="Logo" style={{ width: '80px' }} />
          </Link>
        </Box>

        {/* Menu for large screens */}
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            gap: 1,
            justifyContent: 'center',
            flex: 1,
            flexWrap: 'wrap',
            overflow: 'visible',
          }}
        >
          {pages.map((page) => (
            <Link
              key={page.name}
              to={page.path}
              style={{ textDecoration: 'none', whiteSpace: 'nowrap' }}
            >
              <Button
                sx={{
                  color: activePage === page.name ? '#00aae3' : 'white',
                  fontSize: '15px',
                  fontWeight: '700',
                  fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
                  textTransform: 'uppercase',
                  padding: '8px 12px',
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    width: '0%',
                    height: '2px',
                    backgroundColor: '#00aae3',
                    transform: 'translateX(-50%)',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover::after': {
                    width: '100%',
                  },
                }}
              >
                {page.name}
              </Button>
            </Link>
          ))}
        </Box>

        {/* Social Media Icons for large screens */}
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            gap: 1,
            alignItems: 'center',
            flexShrink: 0,
          }}
        >
          <a
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <Button variant="contained" sx={orderButtonSx}>
              Order Now
            </Button>
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/DongHungVienBakery/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Đông Hưng Viên Bakery on Facebook (opens in a new tab)"
          >
            <IconButton
              sx={{
                backgroundColor: 'white',
                color: '#00aae3',
                '&:hover': { backgroundColor: '#f1f1f1' },
                width: 32,
                height: 32,
              }}
            >
              <FacebookOutlinedIcon />
            </IconButton>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/donghungvienbakery/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Đông Hưng Viên Bakery on Instagram (opens in a new tab)"
          >
            <IconButton
              sx={{
                backgroundColor: 'white',
                color: '#00aae3',
                '&:hover': { backgroundColor: '#f1f1f1' },
                width: 32,
                height: 32,
              }}
            >
              <InstagramIcon />
            </IconButton>
          </a>

          {/* TikTok */}
          <a
            href="https://www.tiktok.com/@donghungvienbakery"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Đông Hưng Viên Bakery on TikTok (opens in a new tab)"
          >
            <IconButton
              sx={{
                backgroundColor: 'white',
                color: '#00aae3',
                '&:hover': { backgroundColor: '#f1f1f1' },
                width: 32,
                height: 32,
              }}
            >
              <img width={'18px'} src={TikTokIcon} alt="" />
            </IconButton>
          </a>
        </Box>

        {/* Mobile: Order Now + Hamburger grouped on the right */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1, ml: 'auto' }}>
          <a
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <Button variant="contained" sx={{ ...orderButtonSx, fontSize: '14px', px: 3, py: 1.2, minHeight: 44 }}>
              Order Now
            </Button>
          </a>
          <IconButton
            size="large"
            edge="end"
            color="inherit"
            aria-label="Open navigation menu"
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
        </Box>

        {/* Drawer for small screens */}
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          onClose={toggleDrawer(false)}
          sx={{
            '& .MuiDrawer-paper': {
              width: '250px',
              backgroundColor: '#121212',
              color: 'white',
            },
          }}
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
          >
            {/* Menu Items */}
            <List>
              {pages.map((page) => (
                <ListItem
                  key={page.name}
                  disablePadding
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center !important',
                    textAlign: 'center',
                  }}
                >
                  <Link
                    to={page.path}
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                    }}
                  >
                    <ListItemButton
                      sx={{
                        '&:hover': { backgroundColor: '#2c2c2c' },
                      }}
                    >
                      <ListItemText
                        primary={page.name}
                        sx={{
                          textAlign: 'center',
                          color: activePage === page.name ? '#00aae3' : 'white',
                        }}
                      />
                    </ListItemButton>
                  </Link>
                </ListItem>
              ))}
            </List>

            <Divider sx={{ backgroundColor: '#444' }} />

            {/* Social Icons in Drawer */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
                px: 2,
              }}
            >
              <a
                href={ORDER_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', width: '100%' }}
              >
                <Button variant="contained" fullWidth sx={orderButtonSx}>
                  Order Now
                </Button>
              </a>
            </Box>

            <Box
              sx={{
                display: 'flex',
                gap: 2,
                flex: '1',
                justifyContent: 'center',
                marginTop: '10px',
                py: 2,
              }}
            >
              {/* Facebook */}
              <a
                href="https://www.facebook.com/DongHungVienBakery/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit Đông Hưng Viên Bakery on Facebook (opens in a new tab)"
              >
                <IconButton
                  sx={{
                    backgroundColor: 'white',
                    color: '#00aae3',
                    '&:hover': {
                      backgroundColor: '#f1f1f1',
                    },
                    width: 32,
                    height: 32,
                  }}
                >
                  <FacebookOutlinedIcon />
                </IconButton>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/donghungvienbakery/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit Đông Hưng Viên Bakery on Instagram (opens in a new tab)"
              >
                <IconButton
                  sx={{
                    backgroundColor: 'white',
                    color: '#00aae3',
                    '&:hover': {
                      backgroundColor: '#f1f1f1',
                    },
                    width: 32,
                    height: 32,
                  }}
                >
                  <InstagramIcon />
                </IconButton>
              </a>

              {/* TikTok */}
              <a
                href="https://www.tiktok.com/@donghungvienbakery"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit Đông Hưng Viên Bakery on TikTok (opens in a new tab)"
              >
                <IconButton
                  sx={{
                    backgroundColor: 'white',
                    color: '#00aae3',
                    '&:hover': {
                      backgroundColor: '#f1f1f1',
                    },
                    width: 32,
                    height: 32,
                  }}
                >
                  <img
                    width={'18px'}
                    src={TikTokIcon}
                    alt=""
                  />
                </IconButton>
              </a>
            </Box>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
